import { useMemo } from "react";

export const getBrowserCallingSupport = () => {
  const secureContext = Boolean(window.isSecureContext);
  const webRtc = Boolean(window.RTCPeerConnection);
  const microphoneApi = Boolean(navigator.mediaDevices?.getUserMedia);
  const webSocket = Boolean(window.WebSocket);

  const supported = secureContext && webRtc && microphoneApi && webSocket;

  const reason = !secureContext
    ? "Browser calling requires HTTPS."
    : !webRtc
    ? "This browser does not support WebRTC calling."
    : !microphoneApi
    ? "This browser does not support microphone access."
    : !webSocket
    ? "This browser does not support WebSocket connections."
    : null;

  return {
    supported,
    reason,
    checks: {
      secureContext,
      webRtc,
      microphoneApi,
      webSocket,
    },
  };
};

export const useBrowserCallingSupport = () => {
  return useMemo(() => getBrowserCallingSupport(), []);
};
